import React from 'react';
import classNames from 'classnames/bind';
import styles from './AlignBoxInput.module.scss';

const cx = classNames.bind(styles);

const AlignBoxInput = ({
	classArray = [],
	type,
	children = {},
	col = null,
	style = null,
	validation = false,
	validationText = '',
	validationTextAuto = '',
	required = false,
	useLabel = false,
	label = '',
	labelStyle = null,
	validationTextStyle = null,
}) => {
	const data = Array.isArray(children) ? children : [children];
	const colResult = col || data.length;
	return (
		<div
			className={cx(classArray)}
			style={style}
		>
			{useLabel && (
				<strong
					className={cx('tit', { tRequired: required })}
					style={labelStyle}
				>
					{label}
				</strong>
			)}
			<div className={cx(`uialign_${type}`)}>
				{data.map((child, i) => {
					const key = `item${i}`;
					return (
						<div
							className={cx('uialign_item', `col${colResult}`)}
							key={key}
						>
							{child}
						</div>
					);
				})}
			</div>
			{validation && (
				<>
					{validationText && (
						<p
							className={cx('noti_txt')}
							data-testid="validateText"
							style={validationTextStyle}
						>
							{validationText}
						</p>
					)}
					{validationTextAuto && (
						<p
							className={cx('noti_txt')}
							data-testid="validateText"
						>
							{label}
							{validationTextAuto} 입력해주세요.
						</p>
					)}
				</>
			)}
		</div>
	);
};

export default AlignBoxInput;
